<template>
<div class ="row">
    <div class="col-lg-12">
        <h2> Pedido </h2>
        <div class="table-responsive mb-2">
            <table class="table">
                <thead>
                    <tr>
                        <th width="15px">#</th>
                        <th>Platillo</th>
                        <th width="75px">Cantidad</th>
                        <th width="110px">Detalles</th>
                        <th width="50px">Precio</th>
                        <th width="35px">Editar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rEspecial, idx) in order.list" v-bind:key="idx" >
                        <th scope="row" style="vertical-align: middle;"> {{idx + 1 }}  </th>
                        <td style="vertical-align: middle;"> 
                            <div class="form-group">                                                        
                                <select class="form-control" v-model="rEspecial.alimentoId" style="height: 34.32px; border-radius: 5px;">
                                  <option v-for="rAlimento in lAlimentos" v-bind:value="rAlimento.alimentoId" v-bind:key="rAlimento.alimentoId" >
                                      {{rAlimento.nombre}}
                                  </option>
                                </select>
                            </div>
                        </td>
                        <td style="vertical-align: middle;">
                            <input v-model="rEspecial.cantidad" type="text" class="form-control" placeholder=""  style="width:100%">
                        </td>
                        <td style="vertical-align: middle;">
                            <input type="text" class="form-control" placeholder="Anotaciones..." style="height:34.32px; margin:0px; width:100%" v-model="rEspecial.detalles">
                        </td>
                        <td style="vertical-align: middle;">
                            $ {{getPrecio(rEspecial.alimentoId)*rEspecial.cantidad}}
                        </td>
                        <td style="vertical-align: middle;">
                            <button type="button" class="btn btn-secondary btn-sm waves-effect waves-light" style="height:34.32px; margin:0px; width:100%" @click="removePlato(idx)" > <i class="fa fa-trash"/> </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div class="row">
            <div class="col-md-9">
                <h4>Total</h4>
            </div>
            <div class="col-md-1">
                <h4>$</h4>
            </div>
            <div class="col-md-2">
                <h4 class="float-right">{{getTotal()}}</h4>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import ResAlimentos from '@/modules/restaurant/models/ResAlimentos.js';

export default {
    name: 'Lista',
    props: {
        order: Object,        
    },
    mounted(){
        let _this = this;
        ResAlimentos.list(150, {}, function(res){
            console.log('resalimentos', res);
            _this.lAlimentos = res.data.items;
        });
    },
    data() {
        return {
            lAlimentos: []
        }
    },
    methods:{
        removePlato(idx){
            this.order.list.splice(idx,1);
        },
        getPrecio(id){
            var precio
            this.lAlimentos.forEach(element => {
                if(element.alimentoId == id){
                    precio = element.precio
                }
            })
            return precio
        },
        getTotal(){
            var Total = 0; 
            this.order.list.forEach(element => {
                var precio = this.getPrecio(element.alimentoId)
                var cantidad = element.cantidad

                Total = Total+(precio*cantidad)
            })
            return Total
        }
    }
}
</script>